<template>
  <b-col class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <div>
              <b-row>
                <b-col sm="3">
                  <i class="fa fa-bars"></i> {{$t('str.forum-config')}}
                </b-col>
                <b-col sm="9"></b-col>
              </b-row>
            </div>

            <div>
              <b-row style="margin-top:10px;">
                <b-col sm="12">
                  <b-row>
                    <b-col sm="4">{{$t('str.keyword')}}</b-col>
                    <template v-if="$auth.session.get('role') == 'admin'">
                      <b-col sm="4">{{$t('str.office')}}</b-col>
                      <b-col sm="4"></b-col>
                    </template>
                    <template v-else>
                      <b-col sm="8"></b-col>
                    </template>
                  </b-row>
                  <b-row>
                    <b-col sm="4">
                      <b-form-input id="keyword" class="form-control" type="text" name="keyword"
                        :placeholder="$t('str.search')" v-model="keyword"></b-form-input>
                    </b-col>
                    <template v-if="$auth.session.get('role') == 'admin'">
                      <b-col sm="4">
                        <b-form-select id="office" name="office" :plain="true" v-model="office" style="height:100%;">
                          <option value="">All</option>
                          <option v-for="(c, i) in officeSelect" :value="c.value" :key="i">{{c.text}}</option>
                        </b-form-select>
                      </b-col>
                      <b-col sm="4">
                        <buttons button-type="search" @click="getList()" />&nbsp;
                        <buttons button-type="reset_filter" @click="resetFilter()" />
                      </b-col>
                    </template>
                    <template v-else>
                      <b-col sm="8">
                        <buttons button-type="search" @click="getList()" />&nbsp;
                        <buttons button-type="reset_filter" @click="resetFilter()" />
                      </b-col>
                    </template>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>

          <p :class="{'text-center': true, 'd-none': items.length}" class="">{{ $t('str.no-data') }}</p>
          <b-table :class="{'d-none': !items.length}" :hover="hover" :striped="striped" :bordered="bordered"
            :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
            <template slot="can_access_forum" slot-scope="data">
              {{ data.item.can_access_forum ? 'Yes' : 'No' }}
            </template>
            <template slot="action" slot-scope="data">
              <buttons button-type="toggle" :toggle="data.item.can_access_forum" toggleClassIcon="fa-edit" toggleTrueStr="str.deactivate"
                toggleFalseStr="str.activate" @click="toggleForumAccess(data.item.id)" />
            </template>
          </b-table>
          <nav :class="{'d-none': !items.length}">
            <paging :current-page="currentPage" :total-pages="totalPage" @page-changed="pageOneChanged" prev-text="Prev"
              next-text="Next" />
          </nav>
        </b-card>
      </b-col>
    </b-row>
    <confirm-modal :item="confirmDeleteId" @confirm="deleteData" @cancel="cancelDelete"></confirm-modal>
  </b-col>
</template>

<script>
import axios from 'axios'

import Pagination from '@/views/component/Pagination'
import ConfirmModal from '@/views/component/ConfirmModal'
import Buttons from '@/views/component/Buttons'

export default {
  name: 'ForumConfig',
  components: {
    'paging': Pagination,
    'confirm-modal': ConfirmModal,
    'buttons': Buttons
  },
  props: {
    hover: { type: Boolean, default: false },
    striped: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    fixed: { type: Boolean, default: false }
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'name', sortable: true },
        { key: 'can_access_forum', label: 'Forum Access', sortable: true },
        { key: 'action' }
      ],
      keyword: '',
      currentPage: 1,
      totalPage: 0,
      office: '',
      officeSelect: [],
    }
  },
  methods: {
    async getOfficeSelect() {
      this.$auth.checkSession()
      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Office`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })
        let cData = getData.data.data

        for (let i = 0; i < cData.length; i++) {
          this.officeSelect.push({ 'value': cData[i].id, 'text': cData[i].name })
        }
      } catch (e) {
        console.log(e.response)
      }
    },

    async getList(page) {
      this.$auth.checkSession()
      let trail = `?limit=${this.$helper.envi.VUE_APP_PAGING_LIMIT}`
      if (page) trail = `${trail}&page=${page}`
      if (this.keyword != '') trail = `${trail}&keyword=${this.keyword}`
      if (this.office != '') trail = `${trail}&office=${this.office}`

      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Forum/Country${trail}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.items = getData.data.data

        this.currentPage = getData.data.meta.page
        this.totalPage = getData.data.meta.pageCount
      } catch (e) {
        console.log(e.response)
      }
    },
    async toggleForumAccess(id) {
      this.$auth.checkSession()
      let countryId = id
      try {
        let result = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/Forum/ToggleAccess/${countryId}`,
          {
            headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
          })

        this.$toast.success(result.data.meta.message, '', {
          position: 'topCenter'
        })

        this.getList()
      } catch (e) {
        console.log(e.response)
      }
    },

    resetFilter() {
      this.keyword = ''
      this.office = ''
      this.getOfficeSelect()
      this.getList()
    },
    pageOneChanged(pageNum) {
      this.$auth.checkSession()
      this.currentPage = pageNum
      this.getList(pageNum)
    },
  },
  created() {
    this.getOfficeSelect()
    this.getList()
  }
}
</script>